import { isNil, pick, sortBy } from "lodash";

const isStarterFee = addon => addon.code?.includes("starterfee");

function formatCurrency(num) {
  return Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0
  }).format(Number(num));
}

function formatSupTag(name) {
  let formattedName = name;
  for (const c of "‡†^") {
    formattedName = formattedName.replace(c, `<sup>${c}</sup>`);
  }
  return formattedName;
}

function getPriceDetailsArr(offer, contentMap, addons = []) {
  const { plan } = offer;
  // return price as 0, if free trial or flex plan
  if (plan.freeTrialDays > 0) {
    return [
      {
        label: contentMap.get("SUBSCRIPTION_PLAN_DISPLAY_NAME"),
        price: formatCurrency(0)
      }
    ];
  }
  // first line item
  let lineItems = [
    {
      label: contentMap.get("RAMP1_PROGRAM_LABEL"),
      sublabel: contentMap.get("RAMP1_PROGRAM_SUBLABEL"),
      price: formatCurrency(plan.salePrice),
      original: formatCurrency(plan.retailPrice),
      line: 1
    }
  ];

  // include starter fee if available under addons array
  const starterFee = addons.find(isStarterFee);
  if (starterFee) {
    const stFeeItem = {
      label: contentMap.get("STARTER_FEE_LABEL"),
      price: formatCurrency(starterFee.salePrice),
      original: formatCurrency(starterFee.retailPrice),
      line: 2
    };
    lineItems.push(stFeeItem);
  }
  return sortBy(lineItems, "line")?.filter(
    priceDetail => !isNil(priceDetail.label)
  );
}

// ------------------------------------------------------------------------------

const normalizedOffer = ({ plan: offer }) => {
  const { addons, contentMap } = offer;

  let addonsMap = addons.map(addon => {
    let aa = pick(addon, ["retailPrice", "salePrice", "discount"]);
    aa.code = addon.addonItem.baseItem.code;
    aa.name = addon.addonItem.name;
    return aa;
  });

  let offerFormatted = {
    id: offer.id,
    contentMap: contentMap,
    basePlanName: offer.plan.basePlan?.name,
    name: contentMap.get("OFFER_PLAN_NAME"),
    priceDetails: getPriceDetailsArr(offer, contentMap, addonsMap),
    priceTotal: {
      label: contentMap.get("TOTAL_LABEL"),
      price: formatCurrency(offer.plan.freeTrialDays > 0 ? 0 : offer.total),
      original: formatCurrency(offer.subtotal)
    },
    disclaimer: contentMap.get("DISCLAIMER"),
    offerPlanName: formatSupTag(contentMap.get("OFFER_PLAN_NAME")),
    durationUnit: contentMap.get("DURATION_LABEL"),
    marketingMessage: contentMap.get("STARTER_FEE_SUBLABEL") || "",
    totalSubLabel: contentMap.get("TOTAL_SUBLABEL"),
    salesPitch: contentMap.get("SALES_PITCH")
  };
  return offerFormatted;
};

export default normalizedOffer;
